/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  AdjustmentError,
  AdjustmentInvoice,
  AgentState,
  AggregateResult,
  AvailableAction,
  DisputeCategorizeRequest,
  DisputeResolveRequest,
  DisputeSendEmailRequest,
  DisputeSendFailedError,
  DisputeWithdrawRequest,
  DraftUpdateRequest,
  EmailDraft,
  GenerateDraftRequest,
  Invoice,
  InvoiceAttachment,
  InvoiceAttachmentRequest,
  InvoiceCreateUpdateRequest,
  InvoiceDetailError,
  InvoicesAggregateRetrieveParams,
  InvoicesGenerateInsightsCreate200,
  InvoicesListParams,
  InvoicesNotesListParams,
  InvoicesStampedPdfRetrieveParams,
  Note,
  NoteCreateUpdateRequest,
  NoteRequest,
  PaginatedInvoiceListItemList,
  PaginatedNoteList,
  PatchedInvoiceAttachmentRequest,
  PatchedInvoiceCreateUpdateRequest,
  PatchedNoteRequest,
  TimelineEntry
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type invoicesListResponse200 = {
  data: PaginatedInvoiceListItemList
  status: 200
}

export type invoicesListResponseSuccess = (invoicesListResponse200) & {
  headers: Headers;
};
;

export type invoicesListResponse = (invoicesListResponseSuccess)

export const getInvoicesListUrl = (params?: InvoicesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["cars","dispute_status","kind","portfolio","region","rejection_category","service_provider","status","type"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/invoices/?${stringifiedParams}` : `/api/v1/invoices/`
}

/**
 * Basic API CRUD access to Invoice entities.
 */
export const invoicesList = async (params?: InvoicesListParams, options?: RequestInit): Promise<invoicesListResponse> => {

  return customFetch<invoicesListResponse>(getInvoicesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesCreateResponse201 = {
  data: Invoice
  status: 201
}

export type invoicesCreateResponseSuccess = (invoicesCreateResponse201) & {
  headers: Headers;
};
;

export type invoicesCreateResponse = (invoicesCreateResponseSuccess)

export const getInvoicesCreateUrl = () => {




  return `/api/v1/invoices/`
}

/**
 * Basic API CRUD access to Invoice entities.
 */
export const invoicesCreate = async (invoiceCreateUpdateRequest: InvoiceCreateUpdateRequest, options?: RequestInit): Promise<invoicesCreateResponse> => {

  return customFetch<invoicesCreateResponse>(getInvoicesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(invoiceCreateUpdateRequest)
  }
);}


export type invoicesAdjustmentsListResponse200 = {
  data: AdjustmentInvoice[]
  status: 200
}

export type invoicesAdjustmentsListResponse404 = {
  data: AdjustmentError
  status: 404
}

export type invoicesAdjustmentsListResponseSuccess = (invoicesAdjustmentsListResponse200) & {
  headers: Headers;
};
export type invoicesAdjustmentsListResponseError = (invoicesAdjustmentsListResponse404) & {
  headers: Headers;
};

export type invoicesAdjustmentsListResponse = (invoicesAdjustmentsListResponseSuccess | invoicesAdjustmentsListResponseError)

export const getInvoicesAdjustmentsListUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/adjustments/`
}

/**
 * GET /api/v1/invoices/{id}/adjustments/ — list all adjustments.
 */
export const invoicesAdjustmentsList = async (invoicePk: string, options?: RequestInit): Promise<invoicesAdjustmentsListResponse> => {

  return customFetch<invoicesAdjustmentsListResponse>(getInvoicesAdjustmentsListUrl(invoicePk),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesAdjustmentsLinkCreateResponse201 = {
  data: AdjustmentInvoice
  status: 201
}

export type invoicesAdjustmentsLinkCreateResponse400 = {
  data: AdjustmentError
  status: 400
}

export type invoicesAdjustmentsLinkCreateResponse404 = {
  data: AdjustmentError
  status: 404
}

export type invoicesAdjustmentsLinkCreateResponseSuccess = (invoicesAdjustmentsLinkCreateResponse201) & {
  headers: Headers;
};
export type invoicesAdjustmentsLinkCreateResponseError = (invoicesAdjustmentsLinkCreateResponse400 | invoicesAdjustmentsLinkCreateResponse404) & {
  headers: Headers;
};

export type invoicesAdjustmentsLinkCreateResponse = (invoicesAdjustmentsLinkCreateResponseSuccess | invoicesAdjustmentsLinkCreateResponseError)

export const getInvoicesAdjustmentsLinkCreateUrl = (invoicePk: string,
    adjustmentId: string,) => {




  return `/api/v1/invoices/${invoicePk}/adjustments/link/${adjustmentId}/`
}

/**
 * POST /api/v1/invoices/{id}/adjustments/link/{adj_id}/ — link existing invoice as adjustment.
 */
export const invoicesAdjustmentsLinkCreate = async (invoicePk: string,
    adjustmentId: string, options?: RequestInit): Promise<invoicesAdjustmentsLinkCreateResponse> => {

  return customFetch<invoicesAdjustmentsLinkCreateResponse>(getInvoicesAdjustmentsLinkCreateUrl(invoicePk,adjustmentId),
  {
    ...options,
    method: 'POST'


  }
);}


export type invoicesAdjustmentsUnlinkCreateResponse204 = {
  data: void
  status: 204
}

export type invoicesAdjustmentsUnlinkCreateResponse404 = {
  data: AdjustmentError
  status: 404
}

export type invoicesAdjustmentsUnlinkCreateResponseSuccess = (invoicesAdjustmentsUnlinkCreateResponse204) & {
  headers: Headers;
};
export type invoicesAdjustmentsUnlinkCreateResponseError = (invoicesAdjustmentsUnlinkCreateResponse404) & {
  headers: Headers;
};

export type invoicesAdjustmentsUnlinkCreateResponse = (invoicesAdjustmentsUnlinkCreateResponseSuccess | invoicesAdjustmentsUnlinkCreateResponseError)

export const getInvoicesAdjustmentsUnlinkCreateUrl = (invoicePk: string,
    adjustmentId: string,) => {




  return `/api/v1/invoices/${invoicePk}/adjustments/unlink/${adjustmentId}/`
}

/**
 * POST /api/v1/invoices/{id}/adjustments/unlink/{adj_id}/ — remove adjustment link.
 */
export const invoicesAdjustmentsUnlinkCreate = async (invoicePk: string,
    adjustmentId: string, options?: RequestInit): Promise<invoicesAdjustmentsUnlinkCreateResponse> => {

  return customFetch<invoicesAdjustmentsUnlinkCreateResponse>(getInvoicesAdjustmentsUnlinkCreateUrl(invoicePk,adjustmentId),
  {
    ...options,
    method: 'POST'


  }
);}


export type invoicesAttachmentsListResponse200 = {
  data: InvoiceAttachment[]
  status: 200
}

export type invoicesAttachmentsListResponseSuccess = (invoicesAttachmentsListResponse200) & {
  headers: Headers;
};
;

export type invoicesAttachmentsListResponse = (invoicesAttachmentsListResponseSuccess)

export const getInvoicesAttachmentsListUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/attachments/`
}

export const invoicesAttachmentsList = async (invoicePk: string, options?: RequestInit): Promise<invoicesAttachmentsListResponse> => {

  return customFetch<invoicesAttachmentsListResponse>(getInvoicesAttachmentsListUrl(invoicePk),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesAttachmentsCreateResponse201 = {
  data: InvoiceAttachment
  status: 201
}

export type invoicesAttachmentsCreateResponseSuccess = (invoicesAttachmentsCreateResponse201) & {
  headers: Headers;
};
;

export type invoicesAttachmentsCreateResponse = (invoicesAttachmentsCreateResponseSuccess)

export const getInvoicesAttachmentsCreateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/attachments/`
}

export const invoicesAttachmentsCreate = async (invoicePk: string,
    invoiceAttachmentRequest: InvoiceAttachmentRequest, options?: RequestInit): Promise<invoicesAttachmentsCreateResponse> => {

  return customFetch<invoicesAttachmentsCreateResponse>(getInvoicesAttachmentsCreateUrl(invoicePk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(invoiceAttachmentRequest)
  }
);}


export type invoicesAttachmentsRetrieveResponse200 = {
  data: InvoiceAttachment
  status: 200
}

export type invoicesAttachmentsRetrieveResponseSuccess = (invoicesAttachmentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type invoicesAttachmentsRetrieveResponse = (invoicesAttachmentsRetrieveResponseSuccess)

export const getInvoicesAttachmentsRetrieveUrl = (invoicePk: string,
    id: string,) => {




  return `/api/v1/invoices/${invoicePk}/attachments/${id}/`
}

export const invoicesAttachmentsRetrieve = async (invoicePk: string,
    id: string, options?: RequestInit): Promise<invoicesAttachmentsRetrieveResponse> => {

  return customFetch<invoicesAttachmentsRetrieveResponse>(getInvoicesAttachmentsRetrieveUrl(invoicePk,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesAttachmentsUpdateResponse200 = {
  data: InvoiceAttachment
  status: 200
}

export type invoicesAttachmentsUpdateResponseSuccess = (invoicesAttachmentsUpdateResponse200) & {
  headers: Headers;
};
;

export type invoicesAttachmentsUpdateResponse = (invoicesAttachmentsUpdateResponseSuccess)

export const getInvoicesAttachmentsUpdateUrl = (invoicePk: string,
    id: string,) => {




  return `/api/v1/invoices/${invoicePk}/attachments/${id}/`
}

export const invoicesAttachmentsUpdate = async (invoicePk: string,
    id: string,
    invoiceAttachmentRequest: InvoiceAttachmentRequest, options?: RequestInit): Promise<invoicesAttachmentsUpdateResponse> => {

  return customFetch<invoicesAttachmentsUpdateResponse>(getInvoicesAttachmentsUpdateUrl(invoicePk,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(invoiceAttachmentRequest)
  }
);}


export type invoicesAttachmentsPartialUpdateResponse200 = {
  data: InvoiceAttachment
  status: 200
}

export type invoicesAttachmentsPartialUpdateResponseSuccess = (invoicesAttachmentsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type invoicesAttachmentsPartialUpdateResponse = (invoicesAttachmentsPartialUpdateResponseSuccess)

export const getInvoicesAttachmentsPartialUpdateUrl = (invoicePk: string,
    id: string,) => {




  return `/api/v1/invoices/${invoicePk}/attachments/${id}/`
}

export const invoicesAttachmentsPartialUpdate = async (invoicePk: string,
    id: string,
    patchedInvoiceAttachmentRequest?: PatchedInvoiceAttachmentRequest, options?: RequestInit): Promise<invoicesAttachmentsPartialUpdateResponse> => {

  return customFetch<invoicesAttachmentsPartialUpdateResponse>(getInvoicesAttachmentsPartialUpdateUrl(invoicePk,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedInvoiceAttachmentRequest)
  }
);}


export type invoicesAttachmentsDestroyResponse204 = {
  data: void
  status: 204
}

export type invoicesAttachmentsDestroyResponseSuccess = (invoicesAttachmentsDestroyResponse204) & {
  headers: Headers;
};
;

export type invoicesAttachmentsDestroyResponse = (invoicesAttachmentsDestroyResponseSuccess)

export const getInvoicesAttachmentsDestroyUrl = (invoicePk: string,
    id: string,) => {




  return `/api/v1/invoices/${invoicePk}/attachments/${id}/`
}

export const invoicesAttachmentsDestroy = async (invoicePk: string,
    id: string, options?: RequestInit): Promise<invoicesAttachmentsDestroyResponse> => {

  return customFetch<invoicesAttachmentsDestroyResponse>(getInvoicesAttachmentsDestroyUrl(invoicePk,id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type invoicesDisputeRetrieveResponse200 = {
  data: AgentState
  status: 200
}

export type invoicesDisputeRetrieveResponseSuccess = (invoicesDisputeRetrieveResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeRetrieveResponse = (invoicesDisputeRetrieveResponseSuccess)

export const getInvoicesDisputeRetrieveUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/`
}

/**
 * Full dispute agent state for the invoice.
 */
export const invoicesDisputeRetrieve = async (invoicePk: string, options?: RequestInit): Promise<invoicesDisputeRetrieveResponse> => {

  return customFetch<invoicesDisputeRetrieveResponse>(getInvoicesDisputeRetrieveUrl(invoicePk),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesDisputeActionsListResponse200 = {
  data: AvailableAction[]
  status: 200
}

export type invoicesDisputeActionsListResponseSuccess = (invoicesDisputeActionsListResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeActionsListResponse = (invoicesDisputeActionsListResponseSuccess)

export const getInvoicesDisputeActionsListUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/actions/`
}

/**
 * Actions currently available for the dispute.
 */
export const invoicesDisputeActionsList = async (invoicePk: string, options?: RequestInit): Promise<invoicesDisputeActionsListResponse> => {

  return customFetch<invoicesDisputeActionsListResponse>(getInvoicesDisputeActionsListUrl(invoicePk),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesDisputeCategorizeCreateResponse200 = {
  data: AgentState
  status: 200
}

export type invoicesDisputeCategorizeCreateResponseSuccess = (invoicesDisputeCategorizeCreateResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeCategorizeCreateResponse = (invoicesDisputeCategorizeCreateResponseSuccess)

export const getInvoicesDisputeCategorizeCreateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/categorize/`
}

/**
 * POST /api/v1/invoices/{id}/dispute/categorize/
 */
export const invoicesDisputeCategorizeCreate = async (invoicePk: string,
    disputeCategorizeRequest: DisputeCategorizeRequest, options?: RequestInit): Promise<invoicesDisputeCategorizeCreateResponse> => {

  return customFetch<invoicesDisputeCategorizeCreateResponse>(getInvoicesDisputeCategorizeCreateUrl(invoicePk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(disputeCategorizeRequest)
  }
);}


export type invoicesDisputeDraftRetrieveResponse200 = {
  data: EmailDraft
  status: 200
}

export type invoicesDisputeDraftRetrieveResponseSuccess = (invoicesDisputeDraftRetrieveResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeDraftRetrieveResponse = (invoicesDisputeDraftRetrieveResponseSuccess)

export const getInvoicesDisputeDraftRetrieveUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/draft/`
}

/**
 * Get the current dispute draft.
 */
export const invoicesDisputeDraftRetrieve = async (invoicePk: string, options?: RequestInit): Promise<invoicesDisputeDraftRetrieveResponse> => {

  return customFetch<invoicesDisputeDraftRetrieveResponse>(getInvoicesDisputeDraftRetrieveUrl(invoicePk),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesDisputeDraftUpdateResponse200 = {
  data: EmailDraft
  status: 200
}

export type invoicesDisputeDraftUpdateResponseSuccess = (invoicesDisputeDraftUpdateResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeDraftUpdateResponse = (invoicesDisputeDraftUpdateResponseSuccess)

export const getInvoicesDisputeDraftUpdateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/draft/`
}

/**
 * Update the current dispute draft.
 */
export const invoicesDisputeDraftUpdate = async (invoicePk: string,
    draftUpdateRequest?: DraftUpdateRequest, options?: RequestInit): Promise<invoicesDisputeDraftUpdateResponse> => {

  return customFetch<invoicesDisputeDraftUpdateResponse>(getInvoicesDisputeDraftUpdateUrl(invoicePk),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(draftUpdateRequest)
  }
);}


export type invoicesDisputeDraftDestroyResponse200 = {
  data: AgentState
  status: 200
}

export type invoicesDisputeDraftDestroyResponseSuccess = (invoicesDisputeDraftDestroyResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeDraftDestroyResponse = (invoicesDisputeDraftDestroyResponseSuccess)

export const getInvoicesDisputeDraftDestroyUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/draft/`
}

/**
 * Discard the current dispute draft; returns updated state.
 */
export const invoicesDisputeDraftDestroy = async (invoicePk: string, options?: RequestInit): Promise<invoicesDisputeDraftDestroyResponse> => {

  return customFetch<invoicesDisputeDraftDestroyResponse>(getInvoicesDisputeDraftDestroyUrl(invoicePk),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type invoicesDisputeGenerateDraftCreateResponse200 = {
  data: EmailDraft
  status: 200
}

export type invoicesDisputeGenerateDraftCreateResponseSuccess = (invoicesDisputeGenerateDraftCreateResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeGenerateDraftCreateResponse = (invoicesDisputeGenerateDraftCreateResponseSuccess)

export const getInvoicesDisputeGenerateDraftCreateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/generate-draft/`
}

/**
 * POST /api/v1/invoices/{id}/dispute/generate-draft/
 */
export const invoicesDisputeGenerateDraftCreate = async (invoicePk: string,
    generateDraftRequest: GenerateDraftRequest, options?: RequestInit): Promise<invoicesDisputeGenerateDraftCreateResponse> => {

  return customFetch<invoicesDisputeGenerateDraftCreateResponse>(getInvoicesDisputeGenerateDraftCreateUrl(invoicePk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateDraftRequest)
  }
);}


export type invoicesDisputeInitiateCreateResponse201 = {
  data: AgentState
  status: 201
}

export type invoicesDisputeInitiateCreateResponseSuccess = (invoicesDisputeInitiateCreateResponse201) & {
  headers: Headers;
};
;

export type invoicesDisputeInitiateCreateResponse = (invoicesDisputeInitiateCreateResponseSuccess)

export const getInvoicesDisputeInitiateCreateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/initiate/`
}

/**
 * POST /api/v1/invoices/{id}/dispute/initiate/
 */
export const invoicesDisputeInitiateCreate = async (invoicePk: string, options?: RequestInit): Promise<invoicesDisputeInitiateCreateResponse> => {

  return customFetch<invoicesDisputeInitiateCreateResponse>(getInvoicesDisputeInitiateCreateUrl(invoicePk),
  {
    ...options,
    method: 'POST'


  }
);}


export type invoicesDisputeReopenCreateResponse200 = {
  data: AgentState
  status: 200
}

export type invoicesDisputeReopenCreateResponseSuccess = (invoicesDisputeReopenCreateResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeReopenCreateResponse = (invoicesDisputeReopenCreateResponseSuccess)

export const getInvoicesDisputeReopenCreateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/reopen/`
}

/**
 * POST /api/v1/invoices/{id}/dispute/reopen/
 */
export const invoicesDisputeReopenCreate = async (invoicePk: string, options?: RequestInit): Promise<invoicesDisputeReopenCreateResponse> => {

  return customFetch<invoicesDisputeReopenCreateResponse>(getInvoicesDisputeReopenCreateUrl(invoicePk),
  {
    ...options,
    method: 'POST'


  }
);}


export type invoicesDisputeResolveCreateResponse200 = {
  data: AgentState
  status: 200
}

export type invoicesDisputeResolveCreateResponseSuccess = (invoicesDisputeResolveCreateResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeResolveCreateResponse = (invoicesDisputeResolveCreateResponseSuccess)

export const getInvoicesDisputeResolveCreateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/resolve/`
}

/**
 * POST /api/v1/invoices/{id}/dispute/resolve/
 */
export const invoicesDisputeResolveCreate = async (invoicePk: string,
    disputeResolveRequest: DisputeResolveRequest, options?: RequestInit): Promise<invoicesDisputeResolveCreateResponse> => {

  return customFetch<invoicesDisputeResolveCreateResponse>(getInvoicesDisputeResolveCreateUrl(invoicePk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(disputeResolveRequest)
  }
);}


export type invoicesDisputeSendCreateResponse200 = {
  data: AgentState
  status: 200
}

export type invoicesDisputeSendCreateResponse502 = {
  data: DisputeSendFailedError
  status: 502
}

export type invoicesDisputeSendCreateResponseSuccess = (invoicesDisputeSendCreateResponse200) & {
  headers: Headers;
};
export type invoicesDisputeSendCreateResponseError = (invoicesDisputeSendCreateResponse502) & {
  headers: Headers;
};

export type invoicesDisputeSendCreateResponse = (invoicesDisputeSendCreateResponseSuccess | invoicesDisputeSendCreateResponseError)

export const getInvoicesDisputeSendCreateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/send/`
}

/**
 * POST /api/v1/invoices/{id}/dispute/send/
 */
export const invoicesDisputeSendCreate = async (invoicePk: string,
    disputeSendEmailRequest?: DisputeSendEmailRequest, options?: RequestInit): Promise<invoicesDisputeSendCreateResponse> => {

  return customFetch<invoicesDisputeSendCreateResponse>(getInvoicesDisputeSendCreateUrl(invoicePk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(disputeSendEmailRequest)
  }
);}


export type invoicesDisputeTimelineListResponse200 = {
  data: TimelineEntry[]
  status: 200
}

export type invoicesDisputeTimelineListResponseSuccess = (invoicesDisputeTimelineListResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeTimelineListResponse = (invoicesDisputeTimelineListResponseSuccess)

export const getInvoicesDisputeTimelineListUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/timeline/`
}

/**
 * GET /api/v1/invoices/{id}/dispute/timeline/
 */
export const invoicesDisputeTimelineList = async (invoicePk: string, options?: RequestInit): Promise<invoicesDisputeTimelineListResponse> => {

  return customFetch<invoicesDisputeTimelineListResponse>(getInvoicesDisputeTimelineListUrl(invoicePk),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesDisputeWithdrawCreateResponse200 = {
  data: AgentState
  status: 200
}

export type invoicesDisputeWithdrawCreateResponseSuccess = (invoicesDisputeWithdrawCreateResponse200) & {
  headers: Headers;
};
;

export type invoicesDisputeWithdrawCreateResponse = (invoicesDisputeWithdrawCreateResponseSuccess)

export const getInvoicesDisputeWithdrawCreateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/dispute/withdraw/`
}

/**
 * POST /api/v1/invoices/{id}/dispute/withdraw/
 */
export const invoicesDisputeWithdrawCreate = async (invoicePk: string,
    disputeWithdrawRequest?: DisputeWithdrawRequest, options?: RequestInit): Promise<invoicesDisputeWithdrawCreateResponse> => {

  return customFetch<invoicesDisputeWithdrawCreateResponse>(getInvoicesDisputeWithdrawCreateUrl(invoicePk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(disputeWithdrawRequest)
  }
);}


export type invoicesNotesListResponse200 = {
  data: PaginatedNoteList
  status: 200
}

export type invoicesNotesListResponseSuccess = (invoicesNotesListResponse200) & {
  headers: Headers;
};
;

export type invoicesNotesListResponse = (invoicesNotesListResponseSuccess)

export const getInvoicesNotesListUrl = (invoicePk: string,
    params?: InvoicesNotesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/invoices/${invoicePk}/notes/?${stringifiedParams}` : `/api/v1/invoices/${invoicePk}/notes/`
}

export const invoicesNotesList = async (invoicePk: string,
    params?: InvoicesNotesListParams, options?: RequestInit): Promise<invoicesNotesListResponse> => {

  return customFetch<invoicesNotesListResponse>(getInvoicesNotesListUrl(invoicePk,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesNotesCreateResponse201 = {
  data: Note
  status: 201
}

export type invoicesNotesCreateResponseSuccess = (invoicesNotesCreateResponse201) & {
  headers: Headers;
};
;

export type invoicesNotesCreateResponse = (invoicesNotesCreateResponseSuccess)

export const getInvoicesNotesCreateUrl = (invoicePk: string,) => {




  return `/api/v1/invoices/${invoicePk}/notes/`
}

export const invoicesNotesCreate = async (invoicePk: string,
    noteCreateUpdateRequest: NoteCreateUpdateRequest, options?: RequestInit): Promise<invoicesNotesCreateResponse> => {

  return customFetch<invoicesNotesCreateResponse>(getInvoicesNotesCreateUrl(invoicePk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(noteCreateUpdateRequest)
  }
);}


export type invoicesNotesRetrieveResponse200 = {
  data: Note
  status: 200
}

export type invoicesNotesRetrieveResponseSuccess = (invoicesNotesRetrieveResponse200) & {
  headers: Headers;
};
;

export type invoicesNotesRetrieveResponse = (invoicesNotesRetrieveResponseSuccess)

export const getInvoicesNotesRetrieveUrl = (invoicePk: string,
    id: string,) => {




  return `/api/v1/invoices/${invoicePk}/notes/${id}/`
}

export const invoicesNotesRetrieve = async (invoicePk: string,
    id: string, options?: RequestInit): Promise<invoicesNotesRetrieveResponse> => {

  return customFetch<invoicesNotesRetrieveResponse>(getInvoicesNotesRetrieveUrl(invoicePk,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesNotesUpdateResponse200 = {
  data: Note
  status: 200
}

export type invoicesNotesUpdateResponseSuccess = (invoicesNotesUpdateResponse200) & {
  headers: Headers;
};
;

export type invoicesNotesUpdateResponse = (invoicesNotesUpdateResponseSuccess)

export const getInvoicesNotesUpdateUrl = (invoicePk: string,
    id: string,) => {




  return `/api/v1/invoices/${invoicePk}/notes/${id}/`
}

export const invoicesNotesUpdate = async (invoicePk: string,
    id: string,
    noteRequest: NoteRequest, options?: RequestInit): Promise<invoicesNotesUpdateResponse> => {

  return customFetch<invoicesNotesUpdateResponse>(getInvoicesNotesUpdateUrl(invoicePk,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(noteRequest)
  }
);}


export type invoicesNotesPartialUpdateResponse200 = {
  data: Note
  status: 200
}

export type invoicesNotesPartialUpdateResponseSuccess = (invoicesNotesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type invoicesNotesPartialUpdateResponse = (invoicesNotesPartialUpdateResponseSuccess)

export const getInvoicesNotesPartialUpdateUrl = (invoicePk: string,
    id: string,) => {




  return `/api/v1/invoices/${invoicePk}/notes/${id}/`
}

export const invoicesNotesPartialUpdate = async (invoicePk: string,
    id: string,
    patchedNoteRequest?: PatchedNoteRequest, options?: RequestInit): Promise<invoicesNotesPartialUpdateResponse> => {

  return customFetch<invoicesNotesPartialUpdateResponse>(getInvoicesNotesPartialUpdateUrl(invoicePk,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedNoteRequest)
  }
);}


export type invoicesNotesDestroyResponse204 = {
  data: void
  status: 204
}

export type invoicesNotesDestroyResponseSuccess = (invoicesNotesDestroyResponse204) & {
  headers: Headers;
};
;

export type invoicesNotesDestroyResponse = (invoicesNotesDestroyResponseSuccess)

export const getInvoicesNotesDestroyUrl = (invoicePk: string,
    id: string,) => {




  return `/api/v1/invoices/${invoicePk}/notes/${id}/`
}

export const invoicesNotesDestroy = async (invoicePk: string,
    id: string, options?: RequestInit): Promise<invoicesNotesDestroyResponse> => {

  return customFetch<invoicesNotesDestroyResponse>(getInvoicesNotesDestroyUrl(invoicePk,id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type invoicesRetrieveResponse200 = {
  data: Invoice
  status: 200
}

export type invoicesRetrieveResponseSuccess = (invoicesRetrieveResponse200) & {
  headers: Headers;
};
;

export type invoicesRetrieveResponse = (invoicesRetrieveResponseSuccess)

export const getInvoicesRetrieveUrl = (id: string,) => {




  return `/api/v1/invoices/${id}/`
}

/**
 * Basic API CRUD access to Invoice entities.
 */
export const invoicesRetrieve = async (id: string, options?: RequestInit): Promise<invoicesRetrieveResponse> => {

  return customFetch<invoicesRetrieveResponse>(getInvoicesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesUpdateResponse200 = {
  data: Invoice
  status: 200
}

export type invoicesUpdateResponseSuccess = (invoicesUpdateResponse200) & {
  headers: Headers;
};
;

export type invoicesUpdateResponse = (invoicesUpdateResponseSuccess)

export const getInvoicesUpdateUrl = (id: string,) => {




  return `/api/v1/invoices/${id}/`
}

/**
 * Basic API CRUD access to Invoice entities.
 */
export const invoicesUpdate = async (id: string,
    invoiceCreateUpdateRequest: InvoiceCreateUpdateRequest, options?: RequestInit): Promise<invoicesUpdateResponse> => {

  return customFetch<invoicesUpdateResponse>(getInvoicesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(invoiceCreateUpdateRequest)
  }
);}


export type invoicesPartialUpdateResponse200 = {
  data: Invoice
  status: 200
}

export type invoicesPartialUpdateResponseSuccess = (invoicesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type invoicesPartialUpdateResponse = (invoicesPartialUpdateResponseSuccess)

export const getInvoicesPartialUpdateUrl = (id: string,) => {




  return `/api/v1/invoices/${id}/`
}

/**
 * Basic API CRUD access to Invoice entities.
 */
export const invoicesPartialUpdate = async (id: string,
    patchedInvoiceCreateUpdateRequest?: PatchedInvoiceCreateUpdateRequest, options?: RequestInit): Promise<invoicesPartialUpdateResponse> => {

  return customFetch<invoicesPartialUpdateResponse>(getInvoicesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedInvoiceCreateUpdateRequest)
  }
);}


export type invoicesDestroyResponse204 = {
  data: void
  status: 204
}

export type invoicesDestroyResponseSuccess = (invoicesDestroyResponse204) & {
  headers: Headers;
};
;

export type invoicesDestroyResponse = (invoicesDestroyResponseSuccess)

export const getInvoicesDestroyUrl = (id: string,) => {




  return `/api/v1/invoices/${id}/`
}

/**
 * Basic API CRUD access to Invoice entities.
 */
export const invoicesDestroy = async (id: string, options?: RequestInit): Promise<invoicesDestroyResponse> => {

  return customFetch<invoicesDestroyResponse>(getInvoicesDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type invoicesGenerateInsightsCreateResponse200 = {
  data: InvoicesGenerateInsightsCreate200
  status: 200
}

export type invoicesGenerateInsightsCreateResponseSuccess = (invoicesGenerateInsightsCreateResponse200) & {
  headers: Headers;
};
;

export type invoicesGenerateInsightsCreateResponse = (invoicesGenerateInsightsCreateResponseSuccess)

export const getInvoicesGenerateInsightsCreateUrl = (id: string,) => {




  return `/api/v1/invoices/${id}/generate-insights/`
}

/**
 * Force-generate and return the invoice's insights object. Returns `{insights: []}` when none were produced, or `{error, code}` on a generation failure.
 */
export const invoicesGenerateInsightsCreate = async (id: string, options?: RequestInit): Promise<invoicesGenerateInsightsCreateResponse> => {

  return customFetch<invoicesGenerateInsightsCreateResponse>(getInvoicesGenerateInsightsCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type invoicesStampedPdfRetrieveResponse200 = {
  data: Blob
  status: 200
}

export type invoicesStampedPdfRetrieveResponse400 = {
  data: InvoiceDetailError
  status: 400
}

export type invoicesStampedPdfRetrieveResponse500 = {
  data: InvoiceDetailError
  status: 500
}

export type invoicesStampedPdfRetrieveResponseSuccess = (invoicesStampedPdfRetrieveResponse200) & {
  headers: Headers;
};
export type invoicesStampedPdfRetrieveResponseError = (invoicesStampedPdfRetrieveResponse400 | invoicesStampedPdfRetrieveResponse500) & {
  headers: Headers;
};

export type invoicesStampedPdfRetrieveResponse = (invoicesStampedPdfRetrieveResponseSuccess | invoicesStampedPdfRetrieveResponseError)

export const getInvoicesStampedPdfRetrieveUrl = (id: string,
    params?: InvoicesStampedPdfRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/invoices/${id}/stamped-pdf/?${stringifiedParams}` : `/api/v1/invoices/${id}/stamped-pdf/`
}

/**
 * Generate and return the stamped invoice PDF as a binary download.
 */
export const invoicesStampedPdfRetrieve = async (id: string,
    params?: InvoicesStampedPdfRetrieveParams, options?: RequestInit): Promise<invoicesStampedPdfRetrieveResponse> => {

  return customFetch<invoicesStampedPdfRetrieveResponse>(getInvoicesStampedPdfRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type invoicesAggregateRetrieveResponse200 = {
  data: AggregateResult
  status: 200
}

export type invoicesAggregateRetrieveResponseSuccess = (invoicesAggregateRetrieveResponse200) & {
  headers: Headers;
};
;

export type invoicesAggregateRetrieveResponse = (invoicesAggregateRetrieveResponseSuccess)

export const getInvoicesAggregateRetrieveUrl = (params: InvoicesAggregateRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/invoices/aggregate/?${stringifiedParams}` : `/api/v1/invoices/aggregate/`
}

/**
 * Basic API CRUD access to Invoice entities.
 */
export const invoicesAggregateRetrieve = async (params: InvoicesAggregateRetrieveParams, options?: RequestInit): Promise<invoicesAggregateRetrieveResponse> => {

  return customFetch<invoicesAggregateRetrieveResponse>(getInvoicesAggregateRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


